import extend from '@/utils/vuex-extend';
import {table} from '@/vuex-extend';
import {wait} from '@/utils/wait';
import moment from 'moment';
import {getAllAdminList} from "@/api/sms/arrival-order";
import {getTotalInfo, getTotalSkuList, purchasedExport} from "@/api/scm/purchase-report";

const today = moment().format('L')
export default extend(table, {
	namespaced: true,
	state: {
		adminList: [],
		totalInfo: {},
		searchForm: {
			time: [`${today} 00:00:00`, `${today} 23:59:59`]
		}
	},
	actions: {
		async getList({state, dispatch}, payload) {
			await wait(dispatch, 'scm.purchase-detail.list', async function () {
				const {searchForm} = state;
				const params = {}
				if (searchForm.value) {
					params[searchForm.select] = searchForm.value
				}
				await dispatch('getData', {
					caller: getTotalSkuList,
					options: {
						...params,
						adminUserId: searchForm.adminUserId,
						startTime: new Date(searchForm.time[0]).getTime() / 1000,
						endTime: new Date(searchForm.time[1]).getTime() / 1000,
						...payload
					}
				})
			})
		},
		async getAllAdminList({dispatch, commit}) {
			await wait(dispatch, 'scm.purchase-detail.list', async function () {
				let response = await getAllAdminList();
				if (response.data) {
					commit('save', {
						adminList: response.data.adminList
					})
				}
			})
		},
		async getTotalInfo({dispatch, commit, state}) {
			await wait(dispatch, 'scm.purchase-detail.list', async function () {
				const {searchForm} = state;
				const params = {}
				if (searchForm.value) {
					params[searchForm.select] = searchForm.value
				}
				let response = await getTotalInfo({
					...params,
					adminUserId: searchForm.adminUserId,
					startTime: new Date(searchForm.time[0]).getTime() / 1000,
					endTime: new Date(searchForm.time[1]).getTime() / 1000,
				});
				if (response.data) {
					commit('save', {
						totalInfo: response.data
					})
				}
			})
		},
		async purchasedExport({dispatch, commit, state}) {
			await wait(dispatch, 'scm.purchase-detail.list', async function () {
				const {searchForm} = state;
				const params = {}
				if (searchForm.value) {
					params[searchForm.select] = searchForm.value
				}
				await purchasedExport({
					...params,
					adminUserId: searchForm.adminUserId,
					startTime: new Date(searchForm.time[0]).getTime() / 1000,
					endTime: new Date(searchForm.time[1]).getTime() / 1000,
				});
			})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/scm/purchase-detail/list.js